export default __webpack_public_path__ + "static/media/hero-img.458ff978.png";